import { render, staticRenderFns } from "./AgricInfo.vue?vue&type=template&id=2a04403f&scoped=true"
import script from "./AgricInfo.vue?vue&type=script&lang=js"
export * from "./AgricInfo.vue?vue&type=script&lang=js"
import style0 from "./AgricInfo.vue?vue&type=style&index=0&id=2a04403f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a04403f",
  null
  
)

export default component.exports